import React, {useCallback} from 'react'
import { useAppDispatch, useAppSelector } from './useReduxHooks'
import { shallowEqual } from 'react-redux'
import {
  FetchNoficationsRequest,
  UpdateNotificationsRequest,
  FetchNotificationsCountRequest,
  DeleteNotificationRequest,
} from '../redux/reducers/notifications/types'
import * as actions from '../redux/reducers/notifications/service'

const useNotifications = () => {
  const dispatch = useAppDispatch()
  const { notifications, listLoading, unreadCount: unreadCountFromState } = useAppSelector((state) => state.notifications, shallowEqual)
  const derivedUnread = React.useMemo(
    () => notifications.filter((n) => !n.read).length,
    [notifications]
  )
  const unreadNotificationCount = unreadCountFromState ?? derivedUnread

  const fetchNotifications = useCallback((vals: FetchNoficationsRequest) => {
    return dispatch(actions.fetchNotifications(vals))
  }, [dispatch])

  /** GET /api/notifications/count — unread count for badge (lighter than full list) */
  const fetchNotificationsCount = useCallback((payload?: FetchNotificationsCountRequest) => {
    return dispatch(actions.fetchNotificationsCount(payload ?? {}))
  }, [dispatch])

  const handleUnseenNotification = useCallback(async (payload: UpdateNotificationsRequest) => {
    return dispatch(actions.updateNotification({ notificationId: payload.notificationId }))
  }, [dispatch])

  /** Mark all as read: POST /api/notifications/mark-all-read; fallback to N×POST /seen if 404 */
  const markAllAsRead = useCallback(async (recipient: string) => {
    const result = await dispatch(actions.markAllNotificationsRead({ recipient }))
    if (actions.markAllNotificationsRead.rejected.match(result)) {
      const unreadIds = notifications.filter((n) => !n.read).map((n) => n._id)
      if (unreadIds.length > 0) {
        await Promise.all(
          unreadIds.map((notificationId) =>
            dispatch(actions.updateNotification({ notificationId }))
          )
        )
      }
    }
    await dispatch(actions.fetchNotifications({ recipient }))
  }, [dispatch, notifications])

  /** Soft-delete one notification: DELETE /api/notifications/:id */
  const deleteNotificationById = useCallback((payload: DeleteNotificationRequest) => {
    return dispatch(actions.deleteNotification(payload))
  }, [dispatch])

  const handeOpenNotification = () => {}

  return {
    notifications,
    listLoading,
    fetchNotifications,
    fetchNotificationsCount,
    unreadNotificationCount,
    handleUnseenNotification,
    markAllAsRead,
    deleteNotificationById,
    handeOpenNotification,
  }
}

export default useNotifications
